export default __webpack_public_path__ + "static/media/DELETE_WHITE.96a4b404.svg";